module.exports = __webpack_public_path__ + "img/icons8-guardian-50.67127449.svg";